import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { FundamentalChartModule } from '../fundamental-chart/fundamental-chart.module';
import { ConfigModule } from 'Angular/config/config.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';

import { SimpleFundChartComponent } from './simple-fund-chart.component';

@NgModule({
    declarations: [SimpleFundChartComponent],
    imports: [BrowserModule, ConfigModule, TooltipModule, FundamentalChartModule],
    exports: [SimpleFundChartComponent],
})
export class SimpleFundChartModule {}
